import noAvatarImg from "../../../assets/noAvatar.png";

const CommentInput = ({ currentUser, desc, setDesc, onSubmit, isSending, cooldown }) => {
    
    const getAvatarSrc = (pic) => {
        // if (!pic) return "/public/noAvatar.png"; 
        if (!pic) return noAvatarImg;
        return pic.startsWith("http") ? pic : "/upload/" + pic;
    };

    const isDisabled = isSending || cooldown > 0;

    return (
        <div className="write">
            <img 
                src={getAvatarSrc(currentUser.profilePic)}
                alt="User Avatar"
            />

            <input 
                type="text" 
                placeholder={cooldown > 0 ? `Please wait for the ${cooldown}s before commenting further...` : "Write a comment..."} 
                value={desc}
                onChange={e => setDesc(e.target.value)}
                onKeyDown={(e) => {
                    if(e.key === 'Enter' && !isDisabled) onSubmit(e);
                }}
                disabled={isDisabled}
            />

            <button onClick={onSubmit} disabled={isDisabled}>
                {cooldown > 0 ? `Wait ${cooldown}s` : (isSending ? "Sending..." : "Send")}
            </button>
        </div>
    );
};

export default CommentInput;